import {
  BackButton,
  CommonButton,
  ExportButton,
  SearchInput,
} from "components";
import useAllQueryParams from "hooks/useGetAllQueryParams/useAllQueryParams";
import React from "react";
import { useTranslation } from "react-i18next";
import { TSetState } from "types/form.types";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

const TableHeader: React.FC<{
  searchable?: boolean;
  exportExcel?: string;
  setSearch: TSetState<string>;
  search: string | undefined;
  title?: React.ReactNode | string;
  headerChildren: React.ReactNode;
  headerChildrenSecondRow: React.ReactNode;
  deletable: boolean;

  selectedRows: any[];
  onDelete: () => void;
  onAddButton?: () => void;
  addButtonTitle?: string;
  dataUrl?: string;
  back?: boolean;
  manualBackButton?: React.ReactNode;
  pdfExport?: () => void;
  pdfExportButton?: boolean
}> = ({
  onAddButton,
  onDelete,

  setSearch,
  searchable,
  exportExcel,
  search,
  headerChildren,
  headerChildrenSecondRow,
  title,
  addButtonTitle,
  dataUrl,
  back,
  manualBackButton,
  pdfExport,
  pdfExportButton
}) => {
    const { t } = useTranslation();

    const allParams = useAllQueryParams();

    const plurals = (value: any) => {
      const parsed = typeof value === 'string' ? JSON.parse(value) : value;

      return Array.isArray(parsed)
        ? parsed.map((item) => String(item?._id))
        : parsed != null
          ? [String(parsed)]
          : [];
    };

    const gradeArray = plurals(allParams?.grade);
    const classIdsArray = plurals(allParams?.classIds);
    const groupIdsArray = plurals(allParams?.groupIds);
    const subjectIdsArray = plurals(allParams?.subjectIds);

    const excludedParams = ['page', 'search', 'limit']; // URLga kiritilmaydigan parametrlar

    const queryParts = [];

    if (gradeArray && gradeArray.length > 0) {
      queryParts.push(`grade=[${gradeArray.join(",")}]`);
    }

    if ((classIdsArray && classIdsArray.length > 0) || (groupIdsArray && groupIdsArray.length > 0)) {
      const classIdsStringArray = classIdsArray.map(String).filter(Boolean);
      const groupIdsStringArray = groupIdsArray.map(String).filter(Boolean);
      const combinedArray = [...groupIdsStringArray, ...classIdsStringArray];

      if (combinedArray.length > 0) {
        queryParts.push(`classIds=["${combinedArray.join('","')}"]`);
      }
    }

    if (subjectIdsArray && subjectIdsArray.length > 0) {
      const stringArray = subjectIdsArray.map((item) => String(item));
      queryParts.push(`subjectIds=["${stringArray.join('","')}"]`);
    }

    for (const [key, value] of Object.entries(allParams)) {
      if (
        value !== undefined &&
        value !== null &&
        key !== 'grade' &&
        key !== 'classIds' &&
        key !== 'groupIds' &&
        key !== 'subjectIds' &&
        !excludedParams.includes(key)
      ) {
        queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
      }
    }

    const exportUrl = `${exportExcel}${queryParts.filter(Boolean).join("&")}`;

    return (
      <div className="table_header">
        <div className="d-flex justify-content-between align-items-center p-2">
          <div className="d-flex align-items-center gap-2">
            {back && <BackButton />}
            {manualBackButton}
            <h2 className="py-2 title">{title} </h2>
            {searchable && (
              <SearchInput
                value={search}
                onChange={(e: any) => {
                  setSearch(e?.target?.value);
                }}
              />
            )}
          </div>
          <div className="d-flex justify-content-end align-items-center mb-2">
            <div className="actions d-flex align-items-center">
              {exportExcel && <ExportButton url={exportUrl} />}
              {
                pdfExportButton && (
                  <CommonButton
                    title={t("general.export")!}
                    className="color-red"
                    startIcon={<PictureAsPdfIcon style={{ fontSize: "25px" }} />}
                    onClick={() => {
                      pdfExport?.()
                    }}
                  />
                )
              }
              <div>{headerChildren}</div>
              {onAddButton && (
                <CommonButton
                  title={addButtonTitle || t("general.add")!}
                  className="main"
                  onClick={() => {
                    onAddButton?.();
                  }}
                />
              )}
              {/* {deletable && selectedRows?.length > 0 && (
              <Button
                style={{ borderRadius: 12 }}
                onClick={onDelete}
                sx={{ width: 40 }}
                variant="outlined"
                color="error"
                // disabled={selectedRows.length <= 0 ? true : false}
                className="table_add_button"
              >
                <DeleteIcon />
              </Button>
            )} */}
            </div>
          </div>
        </div>
        <div>{headerChildrenSecondRow}</div>
      </div>
    );
  };

export default TableHeader;
